module.exports = __webpack_public_path__ + "static/media/246-isle-of-man.096b9968.svg";